module.exports = __webpack_public_path__ + "static/media/tissue.81c6d237.svg";